/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter, SendDataToApi } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SendActivationEmail";
import {
    customSendAccountActivationEmail,
    SendAccountActivationEmailApiParameter, Session
} from '@stoneage/App/Services/Session/SessionService';

type SendActivationEmailParameter = {
    userName: string;
    activateAccount: boolean,
} & HasOnSuccess &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<
    SendActivationEmailParameter,
    SendAccountActivationEmailApiParameter,
    ServiceResult<Session>
>;
export const XPopulateApiParameter: HandlerType = props => {
    let hasSendActivationEmailWhenUserCreatedFromUserAdminPage = (
        getSettingsCollection(props.getState()).customSettings as any
    )?.sendActivationEmailWhenUserCreatedFromUserAdminPage;
    if (hasSendActivationEmailWhenUserCreatedFromUserAdminPage) {
        hasSendActivationEmailWhenUserCreatedFromUserAdminPage = hasSendActivationEmailWhenUserCreatedFromUserAdminPage.toLowerCase() === 'true';
    }
    props.apiParameter = {
        userName: props.parameter.userName,
        activateAccount: hasSendActivationEmailWhenUserCreatedFromUserAdminPage ?? true
    };
};

export const XSendDataToApi: HandlerType = async props => {
    props.apiResult = await customSendAccountActivationEmail(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, XPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XSendDataToApi);
